import { Component, OnInit } from '@angular/core';
import { SeoService } from '../../services/seo.service';

@Component({
  selector: 'app-a-propos',
  standalone: true,
  imports: [],
  templateUrl: './a-propos.component.html',
  styleUrls: ['./a-propos.component.css'],
})
export class AProposComponent implements OnInit {
  constructor(private seo: SeoService) {}

  ngOnInit(): void {
    this.seo.updateMeta(
      'À propos — Qaryos',
      'Qui sommes-nous ? Qaryos conçoit une solution simple et fiable pour tracer, planifier et prouver les rondes de sécurité.'
      // image OG optionnelle :
      // 'https://qaryos.fr/assets/og-cover.jpg'
    );
  }
}
